import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const STATUS_STYLES = {
  generating: "bg-sky-50 text-sky-700 border-sky-200",
  revising: "bg-sky-50 text-sky-700 border-sky-200",
  in_review: "bg-amber-50 text-amber-800 border-amber-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  scheduled: "bg-violet-50 text-violet-700 border-violet-200",
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const STATUS_LABELS = {
  generating: "AI drafting",
  revising: "AI revising",
  in_review: "In review",
  failed: "Failed",
  scheduled: "Scheduled",
  published: "Published",
};

export const BUSY_STATUSES = ["generating", "revising"];

export const MIN_REVIEW_DAYS = 5;

export const minPublishDay = (fromIso) => {
  const d = fromIso ? new Date(fromIso) : new Date();
  d.setUTCDate(d.getUTCDate() + MIN_REVIEW_DAYS);
  return d.toISOString().slice(0, 10);
};

export const StatusPill = ({ status, testId }) => (
  <span
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-mono uppercase tracking-[0.1em] ${STATUS_STYLES[status] || "bg-muted text-foreground/70 border-border"}`}
    data-testid={testId}
  >
    {STATUS_LABELS[status] || status}
  </span>
);

export const fmtDay = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "On approval";

export const AdminGate = ({ returnTo, children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to={`/login?return_to=${encodeURIComponent(returnTo)}`} replace />;
  if (user.role !== "admin") {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <h1 className="font-display text-3xl tracking-tight">Admin only</h1>
        <p className="text-muted-foreground mt-3">Your account doesn&apos;t have admin access.</p>
      </div>
    );
  }
  return children;
};

export const inputCls =
  "w-full rounded-lg border border-border bg-white px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#ac62ea]/40 focus:border-[#ac62ea] transition-colors";

export const FieldLabel = ({ children }) => (
  <span className="text-[11px] font-medium text-foreground/65 uppercase tracking-[0.12em]">{children}</span>
);
